module.exports = __webpack_public_path__ + "static/media/REScreen.24c4711f.png";